<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact Divya

Vue2File : wwwroot\js\components\MegaMenu\MenuDynamicSection.vue
-->
<template>
  <div class="position-relative mm-dynamic-wrapper">
    <component
      :is="selectedMenuComponent"
      v-if="selectedMenuComponent"
      :menu-section-id="selectedMenuSectionId"
      :sort-option="sortOption"
      :specials-heading="specialsHeading"
      :price-type-selection="priceType"
      :set-loading="setLoading"
      class="h-100"
    />
    <loading-bar v-if="showLoading" />
  </div>
</template>

<script>

import MenuImageTiles from  './MenuImageTiles/MenuImageTiles.vue';
import MenuResearchModels from "./MenuResearchModels/MenuResearchModels.vue";
import MenuSpecials from "./MenuSpecials/MenuSpecials.vue";
import MenuPreOwnedSpecials from "./MenuPreOwnedSpecials/MenuPreOwnedSpecials.vue";
import MenuGroupLocations from "./MenuGroupLocations/MenuGroupLocations.vue";

import LoadingBar from "../../../../js/components/shared/LoadingBar.vue";
import { mapWritableState } from "pinia";
import { useMegaMenuStore } from "../../store/MegaMenu/MegaMenuStore";

export default {
  props:{
    defaultMenuComponent: {
      type: String,
      default: ""
    },
    selectedMenuId: {
      type: Number,
      default: null
    }
  },
  data(){
    return{
      selectedMenuSectionId: "",
      selectedMenuComponent: "",
      priceType: "",
      sortOption: "",
      specialsHeading: "",
      showLoading: false
    }
  },
  components: {
    LoadingBar,
   MenuImageTiles,
   MenuResearchModels,
    MenuSpecials,
   MenuPreOwnedSpecials,
   MenuGroupLocations
  },
    computed: {
    ...mapWritableState(useMegaMenuStore, ["menuSectionSettings"]),
  },
  watch: {
    selectedMenuId: {
      handler(newValue) {
        this.loadComponent(newValue);
      },
      immediate: true,
    }
  },
  mounted(){

  },
  methods: {
    loadComponent(menuId) {
      this.clearComponentSettings(); //clear selected menu dynamic component
      const menuSettings = this.getMenuSettings(menuId);
      if(menuSettings) {
        this.$nextTick(() => {
        this.selectedMenuComponent = this.mapComponentName(menuSettings?.componentType);
        this.mapSettings(menuSettings);
        })
      }else if(this.defaultMenuComponent){
        this.selectedMenuComponent = this.defaultMenuComponent;
      }
    },
    getMenuSettings(menuId) {
    return this.menuSectionSettings?.find(item => item.menuId === +menuId)
    },
    mapComponentName(componentType) {
      const ComponentName = {
        FourTileImages: "MenuImageTiles",
        ThreeTileImages: "MenuImageTiles",
        TwoTileImages: "MenuImageTiles",
        OneTileImage: "MenuImageTiles",
        RotationalSpecialBanner: "MenuSpecials",
        PreOwnedRotationSpecials : "MenuPreOwnedSpecials",
        DealerGroupLocations: "MenuGroupLocations",
      };
      return ComponentName[componentType] || componentType;
    },
    mapSettings(menuSettings) {
      const { menuSectionId, componentType, priceType, defaultSortOptions, headerText } = menuSettings;

      this.selectedMenuSectionId = menuSectionId;

      if (componentType?.toLowerCase() === 'preownedrotationspecials') {
        this.priceType = priceType;
        this.sortOption = defaultSortOptions;
        this.specialsHeading = headerText || 'featured pre-owned';
      }
    },
    clearComponentSettings() {
      this.selectedMenuComponent = "";
      this.selectedMenuSectionId = null;
      this.priceType = "";
      this.sortOption = "";
      this.specialsHeading = "";
    },
    setLoading(status) {
      this.showLoading = status;
    },
  }
}
</script>

<style>
.mm-dynamic-wrapper .loading-bar-box {
  position: absolute !important;
}
</style>
